import { buildSubModuleRoute } from '@/app/arch/helpers/RouterHelper';
import Secao from 'Modules/contacard/produto/secao/routes';
import Group from 'Modules/contacard/produto/groups/routes';
import Produtos from 'Modules/contacard/produto/product/routes';
import Marcas from 'Modules/contacard/produto/marca/routes';
import Integrador from 'Modules/contacard/produto/integrador/routes';
import Templates from 'Modules/contacard/produto/templates/routes';

export default [
  buildSubModuleRoute({
    moduleId: 'contacard',
    name: 'produto',
    path: 'produto/',
    subModuleTitle: 'Gerenciar produtos',
    subModuleGroup: [
      {
        title: 'Produtos',
        name: 'productGroup',
      },
      {
        title: 'Complemento',
        name: 'complementGroup',
      },
      {
        title: 'Configurações',
        name: 'configGroup',
      },
    ],
    children: [
      ...Secao,
      ...Group,
      ...Produtos,
      ...Marcas,
      ...Integrador,
      ...Templates,
    ],
  }),
];
